import React, { useEffect, useState } from "react";
import { Col, Row, Select } from "antd";
import CustomTextfield from "../../../../../../../common/input/custom-textfield/custom-textfield";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import CustomSelect from "../../../../../../../common/input/custom-select/custom-select";
import { fetchTeacherList } from "../../../../../../../services/teachers";

const AddNonAcademicContent = ({ showModal, handleSubmit, contentInfo }) => {
  const [value, setValue] = useState("");
  const [teacherId, setTeacherId] = useState(null);
  const [teacherList, setTeacherList] = useState([]);

  const fetchTeacherStatistics = async () => {
    try {
      const response = await fetchTeacherList();
      if (response.status) {
        setTeacherList(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTeacherStatistics();
  }, [showModal.status]);

  useEffect(() => {
    if (showModal.status && contentInfo) {
      setValue(contentInfo?.activity_name);
      setTeacherId(contentInfo?.teacher_id);
    }
  }, [showModal.status, contentInfo]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CustomSelect
            id="techer"
            label="Select Teacher"
            labelColor="#171717"
            placeholder="--Select--"
            size="large"
            value={teacherId}
            onChange={(e) => setTeacherId(e)}
          >
            {teacherList.map((item, index) => (
              <Select.Option key={index} value={item?.id}>
                {item?.full_name}
              </Select.Option>
            ))}
          </CustomSelect>
        </Col>
        <Col span={24}>
          <CustomTextfield
            label={`Enter ${showModal?.modalFor} Name`}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            size="large"
            labelColor="#171717"
            placeholder="Enter Name"
          />
        </Col>
        <Col span={24}>
          <CustomButton
            onClick={() => handleSubmit(value, teacherId)}
            title="Submit"
            type="submit"
            style={{
              marginLeft: "auto",
              marginTop: 10,
              width: "128px",
              height: "40px",
            }}
            variant="outlined"
          />
        </Col>
      </Row>
    </>
  );
};

export default AddNonAcademicContent;
